import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getTranslation, languages } from '../i18n';

const LanguageContext = createContext();

const getLanguageFromPath = () => {
  const pathParts = window.location.pathname.split('/');
  const pathLang = pathParts[1];
  if (pathLang && languages.find(l => l.code === pathLang)) {
    return pathLang;
  }
  return null;
};

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    // Check URL path first (e.g., /it/predictions)
    const pathLang = getLanguageFromPath();
    if (pathLang) return pathLang;
    
    // Then localStorage
    const stored = localStorage.getItem('lotteryx-language');
    if (stored && languages.find(l => l.code === stored)) {
      return stored;
    }
    // Default to English
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('lotteryx-language', currentLang);
  }, [currentLang]);

  const t = useCallback((key) => getTranslation(currentLang, key), [currentLang]);

  const changeLanguage = useCallback((lang) => {
    if (languages.find(l => l.code === lang) && lang !== currentLang) {
      setCurrentLang(lang);
    }
  }, [currentLang]);

  return (
    <LanguageContext.Provider value={{ currentLang, t, changeLanguage, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
